// Who may use what, as the server's ACL (server/config/acl.php) sees the user. The client only uses it to show
// the user what they can use and to spare them a page whose every request would be refused (403); the server is
// what enforces it.
//
//   admin       network_admin
//   privileged  network_admin, network_priv_user
//   support     privileged, and network_supp_user, ci_sluzby_ucebny
//   tacosi-config   admin, and the TACOSI managers (the server says so in `user.can`)
const levels = {
    admin: (user) => user.is_admin,
    privileged: (user) => user.is_privileged_user,
    support: (user) => user.is_support_user,
    'tacosi-config': (user) => (user.can || []).includes('tacosi-config'),
};

export const accessLevels = Object.keys(levels);

// may the user (null = nobody is signed in) do what needs `level`? (no level: every signed-in user)
export function can(user, level) {
    if (!user) {
        return false;
    }
    return !level || levels[level](user);
}
